import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../assetModule/shared/services/http.service';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  faqData: any;
  userGroup: string;

  constructor(private httpService: HttpService, private userService: UserService) { }

  ngOnInit() {
    this.getUserGroup();
    this.httpService.getBasePath().then(e => {
      this.httpService.fetchFaq(this.userService.loggendInUser.userEmailId).subscribe(data => {
        this.faqData = data;
        this.faqData[0].expanded = true;
      });
    });
  }
  getUserGroup() {
    const application = this.userService.loggendInUser.applicationName.filter(name => name.application === 'VAL Web App');
    this.userGroup = application[0].userGroup;
  }
}
